import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	padding: 0 20px;
	height: 100%;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledItemsGrid = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-auto-rows: 330px;
	gap: 10px;
	width: 100%;
	padding: 20px 0;
`;

export { StyledContainer, StyledItemsGrid };
